import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, PrimeTemplate } from 'primeng/api';

import { MessageService } from '../../../services/message.service';
import { Info } from '../../../models/info.model';
import { InfoEnum } from '../../../enumerators/messages.enum';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonDirective } from 'primeng/button';

@Component({
    selector: 'information',
    templateUrl: './information.component.html',
    styleUrls: ['./information.component.scss'],
    standalone: true,
    imports: [ConfirmDialogModule, PrimeTemplate, ButtonDirective]
})
export class InformationComponent {
  message: Info = new Info();

  public isOpen: boolean;
  public animation: string;

  constructor(private messageService: MessageService, private confirmationService: ConfirmationService) {
    this.isOpen = false;
    this.animation = "";
  }

  ngOnInit() {
    this.messageService.startInfoMessage().subscribe((message: Info) => {
      this.getMessageData(message);

      this.message = message;
      this.confirmationService.confirm({
        message: this.message.message,
        header: this.message.title,
        icon: this.message.icon,
        accept: () => {
        },
        reject: () => {
        },
        key: 'information'
      });
    });
  }

  getMessageData(info: Info) {
    switch (info.type) {
      case InfoEnum.Normal:
        break;

      default:
        break;
    }
  }
}
